import zhLocale from 'element-ui/lib/locale/lang/zh-TW'
import home from './zh_cht/home'

const cn = {
    language: '繁体中文',
    message: {
        'home': home,
    },
    '手机号码最小长度为8位': "手機號碼最小長度為8位。",
    '邮箱账号名称最小长度为6位': "郵箱賬號名稱最小長度為6位。",
    '邮箱只能包含英文，数字等字符': "郵箱只能包含英文，數字等字符",
    '请选择正确的收货地址': "請選擇正確的收貨地址。",
    ...zhLocale
}

export default cn
